import React from 'react'

const SENSITIVITY_FACTOR = 20

export default function withEndlessScrolling(WrappedComponent) {
  return class extends React.Component {

    componentDidMount() {
      this.scrollHandler = () => this.handleScroll(this.props)
      this.wrappedContainer.addEventListener('scroll', this.scrollHandler)
      this.checkIfViewportNeedsMoreContent()
    }

    componentDidUpdate(prevProps) {
      const { hasMorePages, isLoading } = this.props

      if(!isLoading && hasMorePages) {
        this.checkIfViewportNeedsMoreContent()
      }
    }

    componentWillUnmount() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
      }
      this.wrappedContainer.removeEventListener('scroll', this.scrollHandler)
    }

    checkIfViewportNeedsMoreContent = () => {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
      }
      this.rafId = requestAnimationFrame(() => {
        this.handleScroll(this.props)
      })
    }

    handleScroll = (props) => {
      const wrappedContainer = this.wrappedContainer || {}
      const { scrollTop, scrollHeight, offsetHeight, clientHeight } = wrappedContainer

      if(!clientHeight || props.isLoading || !props.hasMorePages) {
        return
      }

      if(scrollTop + offsetHeight >= scrollHeight - SENSITIVITY_FACTOR) {
        props.onNextPage()
      }
    }

    render() {

      return (
        <WrappedComponent
          {...this.props}
          provideContainer={ref => this.wrappedContainer = ref} />
        )
    }
  }
}
